import { createApp } from 'vue';
import gallery from './components/Gallery.vue';
import feedback from './components/Feedback.vue';
import comment from './components/Comment.vue';

if(document.getElementById('photos')) {
    const appPhotos = createApp();
    appPhotos.component('gallery', gallery);
    appPhotos.component('feedback', feedback);
    appPhotos.component('comment', comment);
    appPhotos.mount('#app'); // @TODO - Conflict likely - needs checking!
}